import { createFileRoute } from '@tanstack/react-router';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { CreateEnterpriseContainer } from '@mews-commander/onboarding';
import { MewsTeam, RouteType } from '@mews/enums';

const Component = () => {
    const { token } = Route.useParams();

    return <CreateEnterpriseContainer token={token} />;
};

export const Route = createFileRoute('/_public/CreateEnterprise/$token')({
    beforeLoad: ({ context: { checkFeatureFlag } }) => {
        checkFeatureFlag(FeatureFlag.onboardingCreateEnterpriseEnabled);
    },
    component: Component,
    staticData: {
        title: TextKey.OnboardingCreateEnterprisePageTitle,
        owner: MewsTeam.Connectivity,
        type: RouteType.Frontend,
    },
});
